// Our item codes (GS1 AI 240) printed on box labels, with what each product is.
// The Shabuya products, from the "GEN_SHABUYA" list of 2026-10-14.

const ITEM_CODES = {
  "102916": { customer: "SHABUYA", description: "Prime BNLS Beef Flat Iron Trimmed & Roll (Vac. Pack)" },
  "102917": { customer: "SHABUYA", description: "BNLS Beef Cross Rib Block (Angus CH or Prime) *PR-Hawaii*" },
  "102918": { customer: "SHABUYA", description: "FZ BNLS Beef Blade Meat Block (Angus CH or Prime)" },
  "104114": { customer: "SHABUYA", description: "American Wagyu Beef Knuckle Peeled Block (Brn, Raisd & Hrvsd In U.S.A.)" },
  "109317": { customer: "SHABUYA", description: "FZ Beef BNLS Short Plate Roll Block" },
  "202002": { customer: "SHABUYA", description: "BNLS Pork Collar Butt (CT) Block P12" },
  "208000": { customer: "SHABUYA", description: "BNLS Pork Bellies (J-Spec) Block P12" },
  "304190": { customer: "SHABUYA", description: "BNLS Skinless Chicken Thigh Meat Trim & Roll" },
  "502000": { customer: "SHABUYA", description: "BNLS Lamb Shoulder Rolls/Tubes (Frozen)" },
};

export default ITEM_CODES;
